import { API_ENDPOINT } from "@/config/endpoint/endpoint"
import { useRequest } from 'ahooks';

export const useFetchBlogs = (tag: string = '') => {
  return useRequest(async () => {
    const response = await API_ENDPOINT.blogs.getBlogs(tag);
    return response;
  }, {
    cacheKey: `blogs-${tag}`,
    staleTime: 3600
  })
}

export const useFetchBlogDetail = (id: string) => {
  return useRequest(async () => {
    const response = await API_ENDPOINT.blogs.getBlog(id);
    return response;
  }, {
    cacheKey: `blog-detail-${id}`,
    staleTime: 3600
  })
}

export const useFetchTags = () => {
  return useRequest(async () => {
    const response = await API_ENDPOINT.blogs.getTags();
    return response;
  }, {
    cacheKey: `tags`,
    staleTime: 3600
  })
}